import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="quick-input"
export default class extends Controller {
  static targets = ["field"]

  connect() {
  }

  // Set the target field's value to the preset value
  setValue(event) {
    const value = event.currentTarget.dataset.value
    this.fieldTarget.value = value
    let changeEvent = new Event('change')
    this.fieldTarget.dispatchEvent(changeEvent)
  }
}
